module.exports = __webpack_public_path__ + "img/apple-logo-svgrepo-com.8b92cb05.svg";